/** In-app report categories (stored in user_actions.reason JSON as category). */
export const REPORT_REASON_IDS = [
  "harassment",
  "inappropriate_content",
  "spam",
  "scam_fraud",
  "other",
] as const;

export type ReportReasonId = (typeof REPORT_REASON_IDS)[number];
